import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { replaceStrValues } from 'platform/shared/health-apps';
import {
  SpecialMonthlyPensionEvidenceAlert,
  RequestNursingHomeInformationAlert,
} from '../../../components/FormAlerts';
import { isYes, isRelationshipToVeteran } from '../../../utils/helpers';
import content from '../../../utils/content.json';

const getCorrectNoun = formData =>
  isRelationshipToVeteran(formData) === 'custodian' ? 'they' : 'you';

const getCorrectTitle = formData =>
  isRelationshipToVeteran(formData) === 'custodian'
    ? content['claim-information-nursing-home-special-title-custodian']
    : content['claim-information-nursing-home-special-title-default'];

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['claim-information-nursing-home-title']),
    claimingMonthlySpecialPension: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: formData => {
          const title = getCorrectTitle(formData);
          return {
            title,
          };
        },
      },
    },
    needRegularAssistanceAlert: {
      'ui:description': SpecialMonthlyPensionEvidenceAlert,
      'ui:options': {
        hideIf: formData =>
          isYes(formData?.claimantLivesInANursingHome) ||
          !isYes(formData?.claimingMonthlySpecialPension),
        displayEmptyObjectOnReview: true,
      },
    },
    claimantLivesInANursingHome: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: formData => {
          const title = replaceStrValues(
            content['claim-information-nursing-home-lives-in-title'],
            getCorrectNoun(formData),
          );
          return {
            title,
          };
        },
      },
    },
    inNursingHomeAlert: {
      'ui:description': RequestNursingHomeInformationAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.claimantLivesInANursingHome),
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      claimingMonthlySpecialPension: yesNoSchema,
      needRegularAssistanceAlert: {
        type: 'object',
        properties: {},
      },
      claimantLivesInANursingHome: yesNoSchema,
      inNursingHomeAlert: {
        type: 'object',
        properties: {},
      },
    },
    required: ['claimingMonthlySpecialPension', 'claimantLivesInANursingHome'],
  },
};
